import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { applyFroalaAriaFix, stripFroalaWatermark } from '../../../common/utils/froala.utils';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Well, Formation, EditedFormationRecord } from '../../../common/models/well.model';
import { FormationModel } from "../../../form-controls/components/new-casing-plan/models/casing-plan.model";


@Component({
    selector: 'edit-formation-record',
    templateUrl: './edit-formation-record.component.html',
    styleUrls: ['../edit-casing-tubing-record/edit-casing-tubing-record.component.scss', './edit-formation-record.component.scss'],
    standalone: false
})
export class EditFormationRecordComponent implements OnInit {

	editorKey: string;

	@Input() formationTypes: FormationModel[] = [];

	private _froalaOptions: any = null;
	get froalaOptions(): any {
		if (!this._froalaOptions) {
			this._froalaOptions = applyFroalaAriaFix({
				heightMax: 250,
				heightMin: 250,
				key: this.editorKey,
				saveInterval: 0,
				toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough'],
				typingTimer: 150
			});
		}
		return this._froalaOptions;
	}

	form: FormGroup;

	@Input() methods: any[];

	@Output() recordEdited: EventEmitter<EditedFormationRecord> = new EventEmitter<EditedFormationRecord>();

	showModal: boolean = false;

	constructor(private builder: FormBuilder) {
		let conf = window["PdfConfig"] as any;
		this.editorKey = (conf != null) ? conf.editorLicenseKey : "";
	}

	ngOnInit() {


	}

	buildForm(record: EditedFormationRecord): FormGroup {
		let comments: string = record.comments != null
			? record.comments
			: "";

		let formationCode: string = record.selectedFormation;
		let formationOtherValue: string = "";
		let formationItem = this.formationTypes.find(f => f.code === record.selectedFormation);
		if (formationItem == null) {
			//try by AAPG code before we give up and use 'other'
			formationItem = this.formationTypes.find(f => f.aapgCode === record.aapgCode);
			if (formationItem == null) {
				formationCode = 'OTHER';
				formationOtherValue = record.selectedFormation;
			}
		}
		if (formationItem != null && formationItem.code !== record.selectedFormation) {
			formationCode = formationItem.code;
		}
		return this.builder.group({
			id: [{ value: record.id, disabled: true }, []],
			apiNumber: [{ value: record.apiNumber, disabled: true }, []],
			formation: [{ value: formationCode, disabled: false }, [Validators.required]],
			formationOther: [{ value: formationOtherValue, disabled: formationCode != 'OTHER' }, []],
			top: [{ value: record.top, disabled: false }, []],
			bottom: [{ value: record.base, disabled: false }, []],
			producingFormation: [{ value: record.producingFormation, disabled: false }, []],
			showsOf: [{ value: record.showsOf, disabled: false }, []],
			shows: [{ value: record.show, disabled: false }, []],
			methodObtained: [{ value: record.methodObtained, disabled: false }, []],
			aapgCode: [{ value: record.aapgCode, disabled: false }, []],
			isFinal: [{ value: record.isFinal, disabled: false }, []],
			remarks: [{ value: record.remarks, disabled: false }, []],
			comments: [{ value: comments, disabled: false }, [Validators.required]]
		});
	}

	close(): void {
		this.form = null;
		this.showModal = false;
	}

	formationChanged(evt: any): void {
		console.log('changed event', evt);
		let formation = this.formationTypes.find(f => f.code === 'evt');
		if (formation != null) {
			console.log('new formation', formation);
			this.form.get('aapgCode').setValue(formation.aapgCode);
		}
	}

	openForm(record: EditedFormationRecord): void {
		console.log('record in editor', record);
		this.form = this.buildForm(record);
		this.showModal = true;
	}

	save(): void {
		let edit: EditedFormationRecord = new EditedFormationRecord();
		edit.id = this.form.get('id').value;
		edit.apiNumber = this.form.get('apiNumber').value;
		edit.selectedFormation = this.form.get('formation').value;
		edit.top = this.form.get('top').value;
		edit.base = this.form.get('bottom').value;
		edit.producingFormation = this.form.get('producingFormation').value;
		edit.showsOf = this.form.get('showsOf').value;
		edit.show = edit.showsOf != null || this.form.get('shows').value;
		edit.methodObtained = this.form.get('methodObtained').value;
		edit.isFinal = this.form.get('isFinal').value;
		edit.remarks = this.form.get('remarks').value;
		edit.comments = stripFroalaWatermark(this.form.get('comments').value);
		edit.aapgCode = this.form.get('aapgCode').value;
		console.log('emitting', edit);
		this.recordEdited.emit(edit);
		this.showModal = false;
		this.form = null;
	}
}
